import NiceModal from "@ebay/nice-modal-react";

// Modal Imports
import AdministrativeAttachmentsTableModal from "components/modals/form/AdministrativeAttachmentsTableModal";
import AdministrativeModal from "components/modals/form/AdministrativeModal";
import AllocationModal from "components/modals/form/AllocationModal";
import ApproveRejectClaimModal from "components/modals/form/ApproveRejectClaimModal";
import AssessmentAttachmentsTableModal from "components/modals/form/AssessmentAttachmentsTableModal";
import AssessmentModal from "components/modals/form/AssessmentModal";
import AssignConsumerToEquipmentModal from "components/modals/assignment/AssignConsumerToEquipmentModal";
import AssignShippingAndTaxModal from "components/modals/assignment/AssignShippingAndTaxModal";
import AssignTechnicianToAdministrativeModal from "components/modals/assignment/AssignTechnicianToAdministrativeModal";
import AssignTechnicianToAssessmentModal from "components/modals/assignment/AssignTechnicianToAssessmentModal";
import AssignTechnicianToInstallationModal from "components/modals/assignment/AssignTechnicianToInstallationModal";
import AssignTechnicianToMaintenanceRepairModal from "components/modals/assignment/AssignTechnicianToMaintenanceRepairModal";
import AssignTechnicianToTrainingModal from "components/modals/assignment/AssignTechnicianToTrainingModal";
import AssignTechnicianToTravelModal from "components/modals/assignment/AssignTechnicianToTravelModal";
import AttachmentModal from "components/modals/form/AttachmentModal";
import AttestorModal from "components/modals/form/AttestorModal";
import AuditReportModal from "components/modals/form/AuditReportModal";
import BudgetReallocationRequestModal from "components/modals/form/BudgetReallocationRequestModal";
import ConfirmationModal from "components/modals/ConfirmationModal";
import ConsumerModal from "components/modals/form/ConsumerModal";
import ConsumerTransferModal from 'components/modals/form/ConsumerTransferModal';
import ContactsModal from "components/modals/form/ContactsModal";
import EntityModal from "components/modals/form/EntityModal";
import EntityStateFilingFrequencyModal from "components/modals/form/EntityStateFilingFrequencyModal";
import EntityStateModal from "components/modals/form/EntityStateModal";
import EquipmentAttachmentsTableModal from "components/modals/form/EquipmentAttachmentsTableModal";
import EquipmentModal from "components/modals/form/EquipmentModal";
import EquipmentReturnModal from "components/modals/form/EquipmentReturnModal";
import ShippingTaxReturnModal from "components/modals/form/ShippingTaxReturnModal";
import FirstContactAttachmentModal from "components/modals/form/FirstContactAttachmentModal";
import FlagLineItemModal from "components/modals/form/FlagLineItemModal";
import InstallationAttachmentsTableModal from "components/modals/form/InstallationAttachmentsTableModal";
import InstallationModal from "components/modals/form/InstallationModal";
import LineItemAttachmentModal from "components/modals/form/LineItemAttachmentModal";
import MaintenanceRepairAttachmentsTableModal from "components/modals/form/MaintenanceRepairAttachmentsTableModal";
import MaintenanceRepairModal from "components/modals/form/MaintenanceRepairModal";
import MassCostAddAllModal from "components/modals/form/MassCostAddAllModal";
import MassCostEditModal from "components/modals/form/MassCostEditModal";
import NationalOutreachBudgetModal from "components/modals/form/NationalOutreachBudgetModal";
import NationalOutreachBudgetPaymentModal from "components/modals/form/NationalOutreachBudgetPaymentModal";
import NoteModal from "components/modals/form/NoteModal";
import NotificationModal from "components/modals/form/NotificationModal";
import OkayModal from 'components/modals/OkayModal'
import OutreachAttachmentsTableModal from "components/modals/form/OutreachAttachmentsTableModal";
import OutreachModal from "components/modals/form/OutreachModal";
import ProgramYearModal from "components/modals/form/ProgramYearModal";
import ReallocationApproveRejectModal from "components/modals/form/ReallocationApproveRejectModal";
import ReimbursementClaimLineItemModal from "components/modals/form/ReimbursementClaimLineItemModal";
import ReimbursementClaimModal from "components/modals/form/ReimbursementClaimModal";
import ReimbursementClaimPaymentModal from "components/modals/form/ReimbursementClaimPaymentModal";
import ReimbursementClaimRevertModal from "components/modals/form/ReimbursementClaimRevertModal";
import ReimbursementClaimSubmitModal from "components/modals/form/ReimbursementClaimSubmitModal";
import ReimbursementSpreadSheetModal from "components/modals/form/ReimbursementSpreadSheetModal";
import SemiAnnualReportSignerModal from "components/modals/form/SemiAnnualReportSignerModal";
import ShippingAndTaxAttachmentsTableModal from "components/modals/form/ShippingAndTaxAttachmentsTableModal";
import ShippingAndTaxModal from "components/modals/form/ShippingAndTaxModal";
import SubItemAttachmentsTableModal from "components/modals/form/SubItemAttachmentsTableModal";
import SubItemModal from "components/modals/form/SubItemModal";
import TechnicianModal from "components/modals/form/TechnicianModal";
import TrainingAttachmentsTableModal from "components/modals/form/TrainingAttachmentsTableModal";
import TrainingModal from "components/modals/form/TrainingModal";
import TravelAttachmentsTableModal from "components/modals/form/TravelAttachmentsTableModal";
import TravelModal from "components/modals/form/TravelModal";

// Modal Registration
NiceModal.register('AdministrativeAttachmentsTableModal', AdministrativeAttachmentsTableModal)
NiceModal.register('AdministrativeModal', AdministrativeModal)
NiceModal.register('AllocationModal', AllocationModal)
NiceModal.register('ApproveRejectClaimModal', ApproveRejectClaimModal)
NiceModal.register('AssessmentAttachmentsTableModal', AssessmentAttachmentsTableModal)
NiceModal.register('AssessmentModal', AssessmentModal)
NiceModal.register('AssignConsumerToEquipmentModal', AssignConsumerToEquipmentModal)
NiceModal.register('AssignShippingAndTaxModal', AssignShippingAndTaxModal)
NiceModal.register('AssignTechnicianToAdministrativeModal', AssignTechnicianToAdministrativeModal)
NiceModal.register('AssignTechnicianToAssessmentModal', AssignTechnicianToAssessmentModal)
NiceModal.register('AssignTechnicianToInstallationModal', AssignTechnicianToInstallationModal)
NiceModal.register('AssignTechnicianToMaintenanceRepairModal', AssignTechnicianToMaintenanceRepairModal)
NiceModal.register('AssignTechnicianToTrainingModal', AssignTechnicianToTrainingModal)
NiceModal.register('AssignTechnicianToTravelModal', AssignTechnicianToTravelModal)
NiceModal.register('AttachmentModal', AttachmentModal)
NiceModal.register('AttestorModal', AttestorModal)
NiceModal.register('AuditReportModal', AuditReportModal)
NiceModal.register('BudgetReallocationRequestModal', BudgetReallocationRequestModal)
NiceModal.register('ConfirmationModal', ConfirmationModal)
NiceModal.register('ConsumerModal', ConsumerModal)
NiceModal.register('ConsumerTransferModal', ConsumerTransferModal)
NiceModal.register('ContactsModal', ContactsModal)
NiceModal.register('EntityModal', EntityModal)
NiceModal.register('EntityStateFilingFrequencyModal', EntityStateFilingFrequencyModal)
NiceModal.register('EntityStateModal', EntityStateModal)
NiceModal.register('EquipmentAttachmentsTableModal', EquipmentAttachmentsTableModal)
NiceModal.register('EquipmentModal', EquipmentModal)
NiceModal.register('EquipmentReturnModal', EquipmentReturnModal)
NiceModal.register('ShippingTaxReturnModal', ShippingTaxReturnModal)
NiceModal.register('FirstContactAttachmentModal', FirstContactAttachmentModal)
NiceModal.register('FlagLineItemModal', FlagLineItemModal)
NiceModal.register('InstallationAttachmentsTableModal', InstallationAttachmentsTableModal)
NiceModal.register('InstallationModal', InstallationModal)
NiceModal.register('LineItemAttachmentModal', LineItemAttachmentModal)
NiceModal.register('MaintenanceRepairAttachmentsTableModal', MaintenanceRepairAttachmentsTableModal)
NiceModal.register('MaintenanceRepairModal', MaintenanceRepairModal)
NiceModal.register('MassCostAddAllModal', MassCostAddAllModal)
NiceModal.register('MassCostEditModal', MassCostEditModal)
NiceModal.register('NationalOutreachBudgetModal', NationalOutreachBudgetModal)
NiceModal.register('NationalOutreachBudgetPaymentModal', NationalOutreachBudgetPaymentModal)
NiceModal.register('NoteModal', NoteModal)
NiceModal.register('NotificationModal', NotificationModal)
NiceModal.register('OkayModal', OkayModal)
NiceModal.register('OutreachAttachmentsTableModal', OutreachAttachmentsTableModal)
NiceModal.register('OutreachModal', OutreachModal)
NiceModal.register('ProgramYearModal', ProgramYearModal)
NiceModal.register('ReallocationApproveRejectModal', ReallocationApproveRejectModal)
NiceModal.register('ReimbursementClaimLineItemModal', ReimbursementClaimLineItemModal)
NiceModal.register('ReimbursementClaimModal', ReimbursementClaimModal)
NiceModal.register('ReimbursementClaimPaymentModal', ReimbursementClaimPaymentModal)
NiceModal.register('ReimbursementClaimRevertModal', ReimbursementClaimRevertModal)
NiceModal.register('ReimbursementClaimSubmitModal', ReimbursementClaimSubmitModal)
NiceModal.register('ReimbursementSpreadSheetModal', ReimbursementSpreadSheetModal)
NiceModal.register('SemiAnnualReportSignerModal', SemiAnnualReportSignerModal)
NiceModal.register('ShippingAndTaxAttachmentsTableModal', ShippingAndTaxAttachmentsTableModal)
NiceModal.register('ShippingAndTaxModal', ShippingAndTaxModal)
NiceModal.register('SubItemAttachmentsTableModal', SubItemAttachmentsTableModal)
NiceModal.register('SubItemModal', SubItemModal)
NiceModal.register('TechnicianModal', TechnicianModal)
NiceModal.register('TrainingAttachmentsTableModal', TrainingAttachmentsTableModal)
NiceModal.register('TrainingModal', TrainingModal)
NiceModal.register('TravelAttachmentsTableModal', TravelAttachmentsTableModal)
NiceModal.register('TravelModal', TravelModal)
